<template>
  <div
    class="remittance-flag"
    :class="isEnabaled ? 'remittance-flag-enabled' : 'remittance-flag-disabled'"
  >
    <!-- <div
      class="ruppee-icon"
      :class="isEnabaled ? 'ruppee-icon-enabled' : 'ruppee-icon-disabled'"
    >
      ₹
    </div> -->
    <div class="line-height-1">
      {{ $t('invoices.add.form.remittance.chipText') }}
      {{
        isEnabaled
          ? $t('invoices.add.form.remittance.enabled')
          : $t('invoices.add.form.remittance.disabled')
      }}
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isEnabaled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/palette';

.remittance-flag-enabled {
  border-color: map-get($sky-blue, 400);
  background-color: map-get($sky-blue, 50);
}
.remittance-flag-disabled {
  border-color: map-get($mustard-yellow, 400);
  background-color: map-get($mustard-yellow, 50);
}
.remittance-flag {
  border-width: 2px;
  border-style: solid;
  color: map-get($noble-blue, 500);
  border-radius: 1.5rem;
  font-size: 0.75rem;
  height: 1.75rem;
  display: flex;
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
  margin-left: 8px;
  .ruppee-icon-enabled {
    background-color: map-get($sky-blue, 100);
    color: map-get($sky-blue, 400);
  }
  .ruppee-icon-disabled {
    background-color: map-get($mustard-yellow, 100);
    color: map-get($mustard-yellow, 400);
  }
  .ruppee-icon {
    font-weight: bold;
    font-size: 1rem;
    border-radius: 100px;
    padding: 0px 8px;
    text-align: center;
    height: 1.4rem;
    margin-right: 0.5rem;
  }
  .line-height-1 {
    line-height: 1rem;
  }
}
</style>
